import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';

export enum GuaranteesUakdoControllerControlFieldName {
  ExecutorMainDealConditionsStatus = 'executorMainDealConditionsStatus',
  UnfulfilledConditionsDetails = 'unfulfilledConditionsDetails',
  CoverageAccountPlacementStatus = 'coverageAccountPlacementStatus',
  DepositAccountPlacementStatus = 'depositAccountPlacementStatus',
}

export type TGuaranteesUakdoControllerControlFormValues = {
  [GuaranteesUakdoControllerControlFieldName.ExecutorMainDealConditionsStatus]: TAutocompleteOption | null;
  [GuaranteesUakdoControllerControlFieldName.UnfulfilledConditionsDetails]: string;
  [GuaranteesUakdoControllerControlFieldName.CoverageAccountPlacementStatus]: TAutocompleteOption | null;
  [GuaranteesUakdoControllerControlFieldName.DepositAccountPlacementStatus]: TAutocompleteOption | null;
};
